var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/ui/phone-input/phone-input.tsx";
const _excluded = ["value", "onChange", "defaultCountryCode"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { parsePhoneNumber, AsYouType } from 'libphonenumber-js';
import React, { useState, useEffect } from 'react';
import Input from '../input/input';
import CountryCodeDropdown from './country-code-dropdown';
/** Internationalized phone input with country code picker. */
const PhoneInput = props => {
  const {
      value,
      onChange,
      defaultCountryCode = '1'
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const [countryCode, setCountryCode] = useState(defaultCountryCode);
  const [nationalNumber, setNationalNumber] = useState('');
  const handleChange = ({
    target
  }) => {
    // HACK: AsYouType is not meant to be used this way. But it works!
    const asYouType = new AsYouType({
      defaultCallingCode: countryCode
    });
    const formatted = asYouType.input(target.value);

    // If the new value is the same as before, we might be backspacing,
    // so use the actual event value instead of the formatted value.
    if (formatted === nationalNumber && target.value !== nationalNumber) {
      setNationalNumber(target.value);
    } else {
      setNationalNumber(formatted);
    }
  };

  // When the internal state changes, update the external state.
  useEffect(() => {
    if (onChange) {
      try {
        const opts = {
          defaultCallingCode: countryCode,
          extract: false
        };
        const result = parsePhoneNumber(nationalNumber, opts);

        // Throw if the number is invalid, but catch it below.
        // We'll only ever call `onChange` with a valid E164 string or `undefined`.
        if (!result.isPossible()) {
          throw result;
        }
        onChange(result.format('E.164'));
      } catch (e) {
        // The value returned is always a valid E164 string.
        // If it's not valid, it'll return undefined.
        onChange(undefined);
      }
    }
  }, [countryCode, nationalNumber]);
  useEffect(() => {
    handleChange({
      target: {
        value: nationalNumber
      }
    });
  }, [countryCode, nationalNumber]);
  return /*#__PURE__*/React.createElement(Input, _extends({
    onChange: handleChange,
    value: nationalNumber,
    addon: /*#__PURE__*/React.createElement(CountryCodeDropdown, {
      countryCode: countryCode,
      onChange: setCountryCode,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 71,
        columnNumber: 9
      }
    })
  }, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 5
    }
  }));
};
export default PhoneInput;